import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import Card from '../components/Card'
import Image from '../components/Image'
import Row from '../components/Row'
import Text from '../components/Text'

const ImageDate = styled.div`
  color: var(--gray);
  font-size: 0.9rem;
  padding: 1.5rem 0 0 0;
  text-align: center;
`

const CenteredTitle = styled.div`
  font-size: 1.1rem;
  text-align: center;
  margin-bottom: 1rem;
  font-weight: 300;
`

const VFIBold = styled.span`
  font-weight: 700;
`;

function renderSide(src, str, vfi, date) {
  return (
    <Row.Cell>
      <CenteredTitle>
        <Text str={str} />
        {vfi && <VFIBold>{` (${vfi}%)`}</VFIBold>}
      </CenteredTitle>
      <Image src={src} />
      {date && <ImageDate>{date}</ImageDate>}
    </Row.Cell>
  )
}

export default class PatientImages extends Component {
  render() {
    const { left, right, leftVFI, rightVFI, leftDate, rightDate } = this.props

    return (
      <Fragment>
        <Card>
          <Card.Pad>
            <Row>
              {left && renderSide(left, "titles.leftEye", leftVFI, leftDate)}
              {right && renderSide(right, "titles.rightEye", rightVFI, rightDate)}
            </Row>
          </Card.Pad>
        </Card>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PatientImages.js